import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  PromotionDetailType,
  SpecialOfferType,
  PromotionsState,
  PromotionType,
} from "../../../components/CommercialConditions/partials/ProductCommercialConditions/partials/Promotions/utils/types";

const initialState: PromotionsState = {
  promotions: [],
  nextPromotionId: 1,
};

const promotionsSlice = createSlice({
  name: "promotions",
  initialState,
  reducers: {
    addPromotions: (
      state,
      action: PayloadAction<{ promotions: PromotionType[]; reset?: boolean }>,
    ) => {
      const { promotions, reset } = action.payload;

      let newPromotions = reset ? [] : [...state.promotions];

      newPromotions = newPromotions.concat(promotions);
      state.promotions = newPromotions;
      state.nextPromotionId = newPromotions.length + 1;
    },

    addPromotion: (state) => {
      const newPromotion: PromotionType = {
        id: state.nextPromotionId,
        type: SpecialOfferType.BUY_X_GET_Y,
        notes: "",
        promotionDetails: [
          { id: "x", packagedProductId: undefined, units: 1 },
          { id: "y", packagedProductId: undefined, units: 1 },
        ],
      };

      state.promotions.push(newPromotion);
      state.nextPromotionId += 1;
    },

    updatePromotion: (
      state,
      action: PayloadAction<{ id: number; promotion: PromotionType }>,
    ) => {
      const { id, promotion } = action.payload;
      const index = state.promotions.findIndex((p) => p.id === id);

      if (index !== -1) {
        state.promotions[index] = promotion;
      }
    },

    deletePromotion: (state, action: PayloadAction<number>) => {
      state.promotions = state.promotions.filter(
        (p) => p.id !== action.payload,
      );
    },

    updateSpecialOfferType: (
      state,
      action: PayloadAction<{ id: number; type: SpecialOfferType }>,
    ) => {
      const { id, type } = action.payload;
      const promotion = state.promotions.find((p) => p.id === id);

      if (promotion) {
        promotion.type = type;

        // Gérer les détails selon le format
        if (type === SpecialOfferType.BUY_X_GET_Y) {
          promotion.promotionDetails = promotion.promotionDetails.filter(
            (detail) => detail.id !== "z",
          );
        } else if (
          !promotion.promotionDetails.find((detail) => detail.id === "z")
        ) {
          promotion.promotionDetails.push({
            id: "z",
            packagedProductId: undefined,
            units: 1,
          });
        }
      }
    },

    updatePromotionDetail: (
      state,
      action: PayloadAction<{
        promotionId: number;
        detailId: string;
        updates: Partial<PromotionDetailType>;
      }>,
    ) => {
      const { promotionId, detailId, updates } = action.payload;
      const promotion = state.promotions.find((p) => p.id === promotionId);

      if (promotion) {
        const detail = promotion.promotionDetails.find(
          (d) => d.id === detailId,
        );
        if (detail) {
          Object.assign(detail, updates);
        }
      }
    },

    updatePromotionNote: (
      state,
      action: PayloadAction<{ id: number; notes: string }>,
    ) => {
      const { id, notes } = action.payload;
      const promotion = state.promotions.find((p) => p.id === id);

      if (promotion) {
        promotion.notes = notes;
      }
    },

    clearPromotions: (state) => {
      state.promotions = [];
      state.nextPromotionId = 1;
    },

    resetPromotionId: (state) => {
      state.nextPromotionId = 1;
    },
  },
});

export const {
  addPromotions,
  addPromotion,
  updatePromotion,
  deletePromotion,
  updateSpecialOfferType,
  updatePromotionDetail,
  updatePromotionNote,
  clearPromotions,
  resetPromotionId,
} = promotionsSlice.actions;

export default promotionsSlice.reducer;
